<template>
  <v-data-table
    :items="events"
    :headers="headers"
    fixed-header
    height="calc(100vh - 296px)"
    :items-per-page="-1"
    hide-default-footer
  >
    <template v-slot:footer>
      <div class="pa-4 text-right">
        總共 {{ events.length }} 筆約診
      </div>
    </template>
    <template v-slot:item.attend_status="{ item }">
      <img :src="statusIconSrc(item)" width="18">
    </template>
    <template v-slot:item.reserveDate="{ item }">
      {{ forceTaiwanTimestamp(parseInt(item.start_time)) | formatToDate }}
    </template>
    <template v-slot:item.reserveTime="{ item }">
      <span v-html="showReserveTime(item)"/>
    </template>
    <template v-slot:item.sex="{ item }">
      <span>{{ showGender(Number(item.sex)) }}</span>
    </template>
    <template v-slot:item.birthday="{ item }">
      <span>{{ formatROCDate(parseInt(item.birthday) * 1000) }}</span>
    </template>
    <template v-slot:item.reserve_tag="{ item }">
      <div class="d-flex flex-wrap py-1" style="gap: 2px;">
        <v-chip v-for="tag in item.reserve_tag" :key="tag.tag_id">
          #{{ tag.content }}
        </v-chip>
      </div>
    </template>
    <template v-slot:item.detail="{ item }">
      <v-icon color="primary" @click="$emit('showEvent', {event: item, nativeEvent: null})">mdi-eye</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { getReserveIcon, showReserveTime } from '@/utils/tool';
import { assetURL, formatROCDate } from '@/utils/filters';
import { forceTaiwanTimestamp } from '@/utils/timezoneHelper';

export default {
  name: "CalendarList",
  props: {
    events: Array,
  },
  data() {
    return {
      showReserveTime
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('CalendarList.status'), align: 'center', value: 'attend_status', sortable: false, width: 60},
        {text: this.$t('CalendarList.reserveDate'), align: 'center', value: 'reserveDate', sortable: false, width: 120},
        {text: this.$t('CalendarList.reserveTime'), align: 'center', value: 'reserveTime', sortable: false, width: 80},
        {
          text: this.$t('CalendarList.reserveDoctor'),
          align: 'center',
          value: 'doctor_name',
          sortable: false,
          width: 100
        },
        {
          text: this.$t('CalendarList.reserveClinic'),
          align: 'center',
          value: 'clinic_name',
          sortable: false,
          width: 150
        },
        {text: this.$t('CalendarList.patientName'), align: 'center', value: 'name', sortable: false, width: 90},
        {text: this.$t('CalendarList.patientPhone'), align: 'center', value: 'phone', sortable: false, width: 120},
        {text: this.$t('ReserveTable.patientGender'), align: 'center', value: 'sex', sortable: false, width: 60},
        {text: '病患生日', align: 'center', value: 'birthday', sortable: false, width: 140},
        {text: this.$t('CalendarList.note'), align: 'center', value: 'note', sortable: false, width: 150},
        {
          text: this.$t('CalendarList.remindOther'),
          align: 'center',
          value: 'remind_others',
          sortable: false,
          width: 150
        },
        {text: this.$t('CalendarList.reserveTag'), align: 'center', value: 'reserve_tag', sortable: false, width: 150},
        {text: '', align: 'center', value: 'detail', sortable: false},
      ]
    },
  },
  methods: {
    forceTaiwanTimestamp,
    formatROCDate,
    statusIconSrc(item) {
      const iconPath = getReserveIcon(item)
      return assetURL(iconPath)
    },
    showGender(sex) {
      switch (sex) {
        case 0:
          return '女'
        case 1:
          return '男'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>

</style>